import React from 'react';
import { NavigationTabs } from '@ui';
import { NavigationTabsItem } from '@app/components/ui/navigation-tabs/navigation-tabs';
import { navigationRoutes } from '@app/utils/navigation-routes';

export const MonitoringFormsSettingsNavigation = () => {
  const qmManageNavigationList: NavigationTabsItem[] = [
    {
      link: `./`,
      icon: 'FolderIcon',
      label: 'Основные настройки',
      index: 'qm_manage_monitoring_forms_settings',
    },
    {
      link: `./${navigationRoutes.qm_manage_monitoring_forms_criteria_tab}`,
      icon: 'FolderIcon',
      label: 'Критерии',
      index: 'qm_manage_monitoring_forms_settings_criteria',
    },
  ];

  return <NavigationTabs items={qmManageNavigationList} />;
};

export default MonitoringFormsSettingsNavigation;
